import React from "react";
import { Dialog } from "_common/ui/dialogs/Dialog";
import { useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import CompareModalContentProperty from "properties/compare/modal/compare-modal-content-property";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";

export default function CompareModal() {
    const { itemsSelected, isModalOpen, closeModal } = useCompare();
    const items = itemsSelected.filter(
        (item) => item.resource === COMMON_RESOURCE.PROPERTIES || item.resource === COMMON_RESOURCE.UNIT,
    );

    return (
        <Dialog open={isModalOpen} onClose={closeModal} fullScreen fullWidth>
            <CompareModalContentProperty items={items} />
        </Dialog>
    );
}
